export const tabsData = [
  {
    tab_order: 1,
    title: "Tab One",
    content: "Tab one Content",
  },
  {
    tab_order: 2,
    title: "Tab Two",
    content: "Tab two Content",
  },
  {
    tab_order: 3,
    title: "Tab Three",
    content: "Tab three Content",
  },
];
